import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _isEmpty from "lodash/isEmpty";
import _debounce from "lodash/debounce";
import React, { useCallback, useRef } from 'react';
import classNames from 'classnames';
import analyticsModule from '@nerdwallet/analytics';
import styles from './Table.module.less';
export var TableContainer = function TableContainer(_ref) {
  var analytics = _ref.analytics,
      children = _ref.children,
      impressionId = _ref.impressionId,
      fixedHeader = _ref.fixedHeader,
      maxHeight = _ref.maxHeight;
  var ref = useRef(null); // eslint-disable-next-line react-hooks/exhaustive-deps

  var onScroll = useCallback(_debounce(function () {
    var _ref$current;

    if (ref !== null && ref !== void 0 && (_ref$current = ref.current) !== null && _ref$current !== void 0 && _ref$current.scrollLeft && analytics !== null && analytics !== void 0 && analytics.enabled) {
      var _ref$current2;

      var payload = {
        action: 'browse',
        entity_name: 'table_scroll_h',
        interaction_type: 'swipe',
        additional_attributes: {
          // This was originally not nested inside `additional_attributes`,
          // but that nesting is necessary per the event schema. I reached
          // out to Ilona Bodnar to verify if this is a valid change!
          scroll_width: ref === null || ref === void 0 ? void 0 : (_ref$current2 = ref.current) === null || _ref$current2 === void 0 ? void 0 : _ref$current2.scrollLeft
        }
      };

      if (impressionId) {
        payload.impression_id = impressionId;
      }

      analyticsModule.track('table_horizontal_scrolled', payload);
    }
  }, 250), [ref, analytics, impressionId]);

  if (_isEmpty(children)) {
    return null;
  }

  var style = {};

  if (fixedHeader && maxHeight) {
    style = {
      maxHeight: maxHeight
    };
  }

  return /*#__PURE__*/React.createElement("div", {
    className: styles.tableContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.tableBorder, _defineProperty({}, styles.verticalScroll, fixedHeader)),
    onScroll: onScroll,
    ref: ref,
    style: style
  }, children));
};
TableContainer.displayName = 'TableContainer';